import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import _ from 'lodash';

import MatchingCardContainer from './MatchingCardContainer';
import carouselMatchingCardData from './carouselMatchingCardData';
import './MatchingCardCarousel.less';
// import { fetchPages } from '../../../actions/website/PageActions';


// theme tile measurements
const tilePadding = 0;
const tileWidth = 235;

class MatchingCardCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: props.step,
      endPane: undefined
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  // listen for window resize and throttle the request
  componentWillMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    // const { carouselData } = this.props;
    this.setState({
      endPane: (carouselMatchingCardData.length / 4) - 1
    });
  }

  render() {
    const { step } = this.props;
    // const { carouselData } = this.props;
    const carouselViewPortWidth = (tilePadding + tileWidth + tilePadding) * carouselMatchingCardData.length;
    const translatePane = (tilePadding + tileWidth + tilePadding) * step;
    const innerStyle = {
      width: carouselViewPortWidth,
      transform: `translateX(-${translatePane}px)`,
      msTransform: `translateX(-${translatePane}px)`,
    };
    return (
      <div>
        {/* <Arrows step={step} getNextStep={this.getNextStep} getPreviousStep={this.getPreviousStep} startPane={0} endPane={this.state.endPane} /> */}
        <MatchingCardContainer
          step={step}
          themeTileData={carouselMatchingCardData}
          carouselViewPortWidth={carouselViewPortWidth}
          translatePane={translatePane}
          innerStyle={innerStyle}
          tilePadding={tilePadding}
        />
      </div>
    );
  }
}

MatchingCardCarousel.propTypes = {
  step: PropTypes.number,
  // carouselData: PropTypes.arrayOf(PropTypes.shape({})),
};

// const mapDispatchToProps = dispatch => (
//   {
//     getPages: () => dispatch(fetchPages()),
//   }
// );

export default connect(null, null)(MatchingCardCarousel);



/** WEBPACK FOOTER **
 ** ./src/components/common/MatchingCardCarousel/MatchingCardCarousel.jsx
 **/